import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StartReferenceGenerationCommand } from '../../../../core/reference/commands/StartReferenceGenerationCommand';
import { ReferenceModalTypes } from '../../../../core/legacy/reducers/modals';
import { roadSectionsQuery } from '../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../types';
import GenericModal from '../../../legacy/components/ui/modals/GenericModal';
import { ContentContainer, ModalTitle } from '../../../legacy/components/ui/modals/styles';
import { theme } from '../../../legacy/style/theme';

// Same content size and white rounded box as the sessions "Importer" modal (its drop zone is 600 x 300 with
// these margins), without the dashed outline since nothing is dropped here.
const Description = styled.p`
    width: 600px;
    height: 300px;
    margin: 30px 0 20px;
    padding: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    background-color: ${theme.color.white.main};
    border-radius: 10px;
    font-size: ${theme.font.size.medium};
    color: ${theme.color.black.main};
`;

/** Asks for confirmation before generating the référentiel from the sessions. */
const GenerateReferenceModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const hasReference = useAppSelector(roadSectionsQuery).length > 0;

    return (
        <GenericModal
            modalType={ReferenceModalTypes.REFERENCE_GENERATION}
            onValidate={() => dispatch(StartReferenceGenerationCommand())}
            validateButtonText={t('reference.generation.modal.confirm')}
            options={{ notDismissableByClickingOnBackground: true, backgroundColor: theme.color.blue.grey }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.generation.modal.title')}</ModalTitle>
                <Description>
                    {t(hasReference ? 'reference.generation.modal.next' : 'reference.generation.modal.first')}
                </Description>
            </ContentContainer>
        </GenericModal>
    );
};

export default GenerateReferenceModal;
